import React from 'react';

const SensorValueCell = ({value, tableMeta, updateValue}) => {
    const colors = {
      "green": "#5BE12C",
      "yellow": "#F5CD19",
      "red": "#EA4228",
      "blue": "#283bea"
    }

    let backgroundColor = colors.white;
    if ((tableMeta.columnData.name==="mq2" && value >10000) || (tableMeta.columnData.name==="mq9" && value>2000) || (tableMeta.columnData.name==="mq135" && value>1200 ) || (tableMeta.columnData.name==="temp" && value>45) || (tableMeta.columnData.name==="humid" && (value<=30 || value>=70)) || (tableMeta.columnData.name==="bloodOxygen" && value<90) || (tableMeta.columnData.name==="bloodPressureSystolic" && value>140) || (tableMeta.columnData.name==="bloodPressureDiastolic" && value>90) || (tableMeta.columnData.name==="bodyTemperature" && value>38.5) || (tableMeta.columnData.name==="heartRate" && (value<60 || value>120))){
      backgroundColor = colors.red;
    } else if ((tableMeta.columnData.name==="mq2" && (value >50 && value<=10000)) || (tableMeta.columnData.name==="mq9" && (value>300 && value<=2000)) || (tableMeta.columnData.name==="mq135" && (value>100 && value<=1200)) || (tableMeta.columnData.name==="temp" && (value>25 && value<=45)) || (tableMeta.columnData.name==="humid" && ((value>=30 && value<=50) || (value>=60 && value<=70))) || (tableMeta.columnData.name==="bloodOxygen" && (value>=90 && value<=95)) || (tableMeta.columnData.name==="bloodPressureSystolic" && (value>130 && value<=140)) || (tableMeta.columnData.name==="bloodPressureDiastolic" && (value>=80 && value<=90)) || (tableMeta.columnData.name==="bodyTemperature" && (value>37.5 && value<=38.5)) || (tableMeta.columnData.name==="heartRate" && (value>100 && value<=120))) {
        backgroundColor = colors.yellow;
    } 

    return (
        <p style={{backgroundColor:backgroundColor, marginBottom:"0px", padding:"6px 0px 6px 0px", textAlign:"center"}}>
            {value}
        </p>
    )
}

export default SensorValueCell;
